import type { ErrorCode } from '../types'

const ERROR_MESSAGES: Record<ErrorCode, string> = {
  'unsupported-container-or-codec': "This HEIF file uses an encoding we don't support.",
  'corrupt-or-unreadable': "We couldn't read this file. It may be damaged.",
  'file-too-large': 'This file is larger than 30 MB.',
  'too-many-files': 'You can add up to 20 files at a time.',
  'pixel-dimensions-too-large': 'This image is larger than 12,000 px on the longest side.',
  'decoder-init-failed': "The converter couldn't start in this browser.",
  'memory-pressure': 'This browser ran out of memory.',
  'canvas-encode-failed': "Couldn't create the output image.",
  'download-blocked': 'Your browser blocked the download.',
  cancelled: 'Cancelled.',
  unknown: 'An unexpected error occurred.',
}

export function errorMessageFor(code: ErrorCode): string {
  return ERROR_MESSAGES[code]
}
